import {filterByPermissions} from '../helpers';
import * as Income from './incomeOptions';
import * as Process from './processOptions';
import * as Outcome from './outcomeOptions';

const getPartIncomeOptions = (permissions) => {
  const options = [{
    'name': 'Mantenimiento',
    'options': filterByPermissions(permissions, Income.maintenance),
  }, {
    'name': 'Compras',
    'options': filterByPermissions(permissions, Income.purchases),
  },
  {
    'name': 'Consultas',
    'options': filterByPermissions(permissions, Income.query),
  }];

  return options.filter((item) => item.options.length);
};

const getPartProcessOptions = (permissions) => {
  const options = [{
    'name': 'CPD',
    'options': filterByPermissions(permissions, Process.CPD),
  }, {
    'name': 'Devolución de Repuestos',
    'options': filterByPermissions(permissions, Process.partsReturns),
  }, {
    'name': 'Gestión de Inventario',
    'options': filterByPermissions(permissions, Process.inventoryManagement),
  }, {
    'name': 'Gestión de Pedidos',
    'options': filterByPermissions(permissions, Process.ordersManagement),
  }, {
    'name': 'Kardex',
    'options': filterByPermissions(permissions, Process.kardex),
  }, {
    'name': 'Lubricantes',
    'options': filterByPermissions(permissions, Process.lubricants),
  }, {
    'name': 'Mantenimiento CPD',
    'options': filterByPermissions(permissions, Process.maintenance),
  }, {
    'name': 'Transacción de Inventario',
    'options': filterByPermissions(permissions, Process.inventoryTransfer),
  }, {
    'name': 'Facturación Anticipada',
    'options': filterByPermissions(permissions, Process.anticipatedInvoice),
  }];

  return options.filter((item) => item.options.length);
};

const getPartOutcomeOptions = (permissions) => {
  const options = [{
    'name': 'Gestión de KPI\'s',
    'options': filterByPermissions(permissions, Outcome.KPI),
  },
  {
    'name': 'Consultas',
    'options': filterByPermissions(permissions, Outcome.QueryMenuItems),
  }];

  return options.filter((item) => item.options.length);
};

export const getPartsOptions = (permissions) => {
  const options = [{
    'name': 'Entrada',
    'options': getPartIncomeOptions(permissions),
  }, {
    'name': 'Proceso',
    'options': getPartProcessOptions(permissions),
  }, {
    'name': 'Salida',
    'options': getPartOutcomeOptions(permissions),
  }];

  return options.filter((item) => item.options.length);
};

export const partsOptions = [
  ...Income.purchases,
  ...Income.query,
  ...Income.maintenance,
  ...Process.CPD,
  ...Process.maintenance,
  ...Process.inventoryManagement,
  ...Process.ordersManagement,
  ...Process.inventoryTransfer,
  ...Process.partsReturns,
  ...Process.kardex,
  ...Process.lubricants,
  ...Process.anticipatedInvoice,
  ...Outcome.KPI,
  ...Outcome.QueryMenuItems,
];
